import { type ReactElement } from 'react';

import { Button, type ButtonProps, styled } from '@mui/material';

type OmittedProps = 'variant';

export type PrimaryButtonProps = Omit<ButtonProps, OmittedProps>;

const PrimaryButtonBootsrap = styled(Button)<PrimaryButtonProps>(
  ({ theme }) => ({
    '&.MuiButton-contained': {
      fontWeight: 700,
      textTransform: 'none',
      borderRadius: 8,
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.white.main,
      '&:hover': {
        backgroundColor: theme.palette.blue500.main,
      },
      '&.Mui-disabled': {
        border: `1px solid ${theme.palette.gray500.main}`,
        color: theme.palette.gray300.main,
        backgroundColor: theme.palette.gray200.main,
      },
      '&:focus': {
        // outlineOffset: 2,
        // outline: `2px solid ${theme.palette.horizonBlue1.main}`,
        outline: 0,
      },
    },
  }),
);

export const PrimaryButton = (props: PrimaryButtonProps): ReactElement => (
  <PrimaryButtonBootsrap {...props} variant="contained" />
);
